module.exports = __webpack_public_path__ + "img/samsung_g998b.40903ad.jpg";